import { Editor } from '@tiptap/core'
import { BubbleMenu } from '@tiptap/react'
import React, { useCallback, useEffect, useRef } from 'react'
import { ColorPicker } from '../../ColorPicker/ColorPicker'

interface IProps {
  editor: Editor | null
  disabled?: boolean
}

export const EditorSpacerBubbleMenu = ({ editor, disabled }: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const unblur = useCallback(() => {
    if (editor?.isActive('spacer')) {
      editor?.chain().blur().run()
    }
  }, [editor])

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        unblur()
      }
    }

    const handleClickOutside = (e: any) => {
      if (!ref.current?.contains(e.target)) {
        unblur()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', down)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', down)
    }
  }, [unblur])

  const hasSpacerExtension: boolean = !!editor?.extensionManager.extensions.find(
    (e) => e.name === 'image',
  )
  if (!editor || disabled || !hasSpacerExtension) return null
  const spacerHeight = editor.getAttributes('spacer').height
  const spacerBackgroundColor = editor.getAttributes('spacer').backgroundColor
  return (
    <BubbleMenu
      className="bg-body-tertiary border rounded-xs p-2"
      tippyOptions={{
        duration: 150,

        zIndex: 1060,
        placement: 'bottom-end',
        moveTransition: 'transform 0.15s ease-out',
      }}
      editor={editor}
      shouldShow={({ editor: e }) => e.isActive('spacer')}
    >
      <div ref={ref}>
        <div className="d-flex justify-content-between" style={{ minWidth: 200 }}>
          <label className="small">Height</label>
          <div className="small text-body-secondary">{spacerHeight}px</div>
        </div>
        <div>
          <input
            type="range"
            name="checkout_overlay_opacity"
            value={spacerHeight}
            className="form-control-range"
            onChange={(e) => {
              const height = e.target.valueAsNumber
              editor.chain().setSpacerAttributes({ height }).run()
            }}
            step={1}
            min={20}
            max={200}
          />
        </div>
        <div>
          <label className="small">Color</label>
          <ColorPicker
            value={spacerBackgroundColor?.replace('#', '') || ''}
            required
            onChange={(e) => {
              const backgroundColor = e.target.value.includes('#')
                ? e.target.value
                : `#${e.target.value}`
              editor.chain().setSpacerAttributes({ backgroundColor }).run()
            }}
          />
        </div>
      </div>
    </BubbleMenu>
  )
}
